import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'enx-shared-ui-coin-gradient',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './shared-ui-coin-gradient.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('progressAnimation', [
      state('*', style({ strokeDashoffset: '{{ endOffset }}' }), { params: { endOffset: 0 } }),
      transition('* => *', [style({ strokeDashoffset: '{{ startOffset }}' }), animate('4s ease')], {
        params: { startOffset: 0 },
      }),
    ]),
  ],
})
export class SharedUiCoinGradientComponent {
  coinsAmount = input.required<number>();
  fullCircle = input<boolean>(false);
  endOffSet = computed(() =>
    this.fullCircle() ? 0 : this.circumference - (this.coinsAmount() / 500) * this.circumference,
  );
  radius = 67;
  circumference = 2 * Math.PI * this.radius;

  get progressState(): {
    value: number;
    params: {
      startOffset: number;
      endOffset: number;
    };
  } {
    return {
      value: this.coinsAmount(),
      params: {
        startOffset: this.circumference,
        endOffset: this.endOffSet(),
      },
    };
  }
}
